export enum Permission {
  PortalAccess = 'portal-access',
  MobileConsumer = 'mobile-consumer',
  DashboardAdmin = 'dashboard',
  DashboardProducer = 'dashboard-producer',
  StoreAdmin = 'store',
  AuditLogAdmin = 'auditlog',
  PartnerAdmin = 'partner',

  PartnerGroupAdmin = 'partner-group',

  ProductAdmin = 'product',

  OfferAdmin = 'offer',

  NewsAdmin = 'news',

  BannerAdmin = 'banner',
  ReceiptAdmin = 'receipt',
  ReceiptApprover = 'receipt-approver',
  ConsumerAdmin = 'consumer',
  CategoryAdmin = 'category',
  SpinAdmin = 'spin',
  ChatConversationAdmin = 'chat-conversation',

  ChatMessageAdmin = 'chat-message',
  ReportedChatAdmin = 'reported-chat',

  SKUCatalogueAdmin = 'sku-catalogue',

  VoucherAdmin = 'voucher',

  TargetedMarketingAdmin = 'targeted-marketing',
  OpenAIPromptAdmin = 'openai-prompt',
  HobbyInterestCategoryAdmin = 'hobby-interest-category',
  DeliveryAdmin = 'delivery',
  DeliveryApprover = 'delivery-approver',
  DeliveryListAdmin = 'delivery-admin',
  DeliveryMethodAdmin = 'delivery-method',
  ConfigBrandMainAdmin = 'config-brand-main',
  ConfigStoreMainAdmin = 'config-store-main',
  UserRewardAdmin = 'user-reward',
}
